import { render, staticRenderFns } from "./AppointmentDispute.vue?vue&type=template&id=6a5f8bd2&scoped=true&"
import script from "./AppointmentDispute.vue?vue&type=script&lang=js&"
export * from "./AppointmentDispute.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentDispute.vue?vue&type=style&index=0&id=6a5f8bd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5f8bd2",
  null
  
)

export default component.exports